<template>
  <div class="company-home-page" v-loading="loading" v-ps>
    <div class="person">
      <el-card class="box-card">
        <div class="person-info" :style="{ 'background-image': `url(${background})` }">
          <staff-avatar :size="72" :user="personInfo" :compress="false"></staff-avatar>
          <div style="margin-left: 10px; max-width: 600px;">
            <div style="font-size: 20px;" v-tip>
              {{ personInfo.name ? "你好，" + personInfo.name : "无" }}
            </div>
            <div style="font-size: 14px; padding-top: 10px;" v-tip>
              你现在的身份是：
              <span style="color:#1989FA">
                {{ personInfo.companyRole ? personInfo.companyRole : "无" }}
              </span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="company">
      <el-row>
        <el-col :span="11">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="title">企业信息</span>
              <el-tooltip class="item" effect="dark" content="企业信息设置" placement="bottom">
                <span class="setting" @click="goSetting('company-manage-info')">
                  <svg-icon icon-class="company_setting"></svg-icon>
                </span>
              </el-tooltip>
            </div>
            <div class="company-info">
              <div class="logo">
                <img :src="imageUrl" style="max-height: 72px; max-width: 72px;" />
              </div>
              <div style="margin-left: 40px;">
                <div style="font-size: 16px;">
                  {{ companyInfo.name }}
                </div>
                <div style="font-size: 14px; padding-top: 10px">
                  企业编号：{{ companyInfo.code ? companyInfo.code : "无" }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="13" style="padding-left: 10px">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="title">企业成员</span>
              <el-tooltip class="item" effect="dark" content="企业成员设置" placement="bottom">
                <span class="setting" @click="goSetting('company-user')">
                  <svg-icon icon-class="company_setting"></svg-icon>
                </span>
              </el-tooltip>
            </div>
            <div class="member">
              <div v-for="(item, index) in memberInfos" :key="index" class="member-item">
                <div style="display: inline-flex;">
                  <span class="nodeIcon">
                    <svg-icon :icon-class="'company_' + item.icon"></svg-icon>
                  </span>
                  <div style="text-align: left; margin-left: 10px;">
                    <div style="font-size: 27px; color: #606266;">{{ item.count }}</div>
                    <div v-if="item.value !== 'inactive-number'" class="nodeName">
                      {{ item.label }}
                    </div>
                    <div
                      v-else
                      class="nodeName"
                      style="color: #409EFF; cursor: pointer;"
                      @click="goSettingAndSearch('company-user', 'status')"
                    >
                      <span>{{ item.label }}</span>
                      <span>
                        <i class="el-icon-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="shortcut">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="title">快捷入口</span>
        </div>
        <ul class="shortcuts">
          <li
            v-for="(item, index) in companyInfo.syncDing ? shortcuts.slice(2) : shortcuts"
            :key="index"
            @click="
              item.hasOwnProperty('dialog')
                ? goSettingAndOpenDialog(item.router, item.dialog)
                : goSetting(item.router)
            "
          >
            <span class="nodeIcon">
              <svg-icon :icon-class="'company_' + item.icon"></svg-icon>
            </span>
            <div class="nodeName">{{ item.label }}</div>
          </li>
        </ul>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getCompanyDashboardVo } from "@/api/user"
import { shortcuts, memberInfos } from "./static"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "company-home-page",
  components: { StaffAvatar },
  data() {
    return {
      shortcuts,
      memberInfos,
      loading: true,
      personInfo: {},
      companyInfo: { syncDing: false },
      defaultImg: require("@/assets/images/company-logo.png"),
      background: require("@/assets/images/background.png"),
      curCompanyUsers: []
    }
  },
  computed: {
    imageUrl() {
      return this.companyInfo.logo ? this.companyInfo.logo : this.defaultImg
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      getCompanyDashboardVo().then(res => {
        this.personInfo = res.user
        this.companyInfo = res.company
        this.memberInfos[0].count = res.totalUserCount
        this.memberInfos[1].count = res.unLoginUserCount
        this.memberInfos[2].count = res.totalDepartmentCount
        this.loading = false
      })
    },
    goSetting(routeName) {
      this.$router.push({ name: routeName })
    },
    goSettingAndSearch(routeName, searchKey) {
      this.$router.push({
        name: routeName,
        params: {
          searchKey: searchKey
        }
      })
    },
    goSettingAndOpenDialog(routeName, dialogName) {
      this.$router.push({
        name: routeName,
        params: {
          dialogName: dialogName
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.company-home-page {
  margin: -15px 0;
  background-color: #f5f5f5;
  display: flex;
  flex-flow: column;
  height: calc(100vh - 52px);
  .person {
    height: 130px;
    padding: 10px;
    .person-info {
      width: 100%;
      display: inline-flex;
      align-items: center;
      margin: 0 20px;
      background-size: contain;
      background-position: right;
      background-repeat: no-repeat;
      color: #606266;
      .el-avatar {
        font-size: 24px;
      }
    }
    ::v-deep {
      .el-card__body {
        padding: 0;
        height: 130px;
        display: flex;
      }
    }
  }
  .company {
    height: 190px;
    padding: 0 10px 10px 10px;
    .el-row {
      height: 100%;
      .el-col {
        height: 100%;
      }
    }
    .setting {
      float: right;
      padding: 3px 0;
      cursor: pointer;
    }
    .company-info {
      display: inline-flex;
      align-items: center;
      margin-left: 36px;
      color: #606266;
      .logo {
        @include flex-center;
        overflow: hidden;
        box-sizing: border-box;
        width: 72px;
        height: 72px;
        border-radius: 6px;
        border: 1px solid rgb(220, 223, 230);
      }
    }
  }
  .shortcut {
    padding: 0 10px 10px 10px;
    flex: 1;
    ::v-deep {
      .el-card__header {
        padding: 18px 20px 0 20px;
      }
      .el-card__body {
        padding: 0 20px;
      }
    }
  }
  .el-card {
    height: 100%;
    border-radius: 6px;
    border: unset;
    box-shadow: unset;
    ::v-deep .el-card__header {
      border-bottom: none;
    }
  }
  .member {
    line-height: 1.5;
    display: flex;
    white-space: nowrap;
    .member-item {
      flex: 1;
      width: 110px;
      height: 120px;
      text-align: center;
      .nodeIcon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        padding-top: 6px;
        .svg-icon,
        i {
          font-size: 60px;
          color: #fff;
        }
      }
      .nodeName {
        margin-top: 5px;
        line-height: 16px;
        font-size: 14px;
        color: #606266;
      }
    }
  }
  .shortcuts {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    padding-bottom: 12px;
    flex-wrap: wrap;
    font-size: 13px;
    color: #333;
    line-height: 1.5;
    li {
      margin: 12px 30px;
      width: 100px;
      height: 120px;
      display: inline-flex;
      align-items: center;
      flex-direction: column;
      padding: 12px 10px 0;
      text-align: center;
      cursor: pointer;
      list-style: none;
      &:hover {
        border-radius: 2px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      }
      .nodeIcon {
        margin-top: 12px;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        .svg-icon,
        i {
          font-size: 74px;
          color: #fff;
        }
      }
      .nodeName {
        margin-top: 12px;
        line-height: 16px;
        font-size: 14px;
        color: #606266;
      }
    }
  }
  .title {
    font-size: 18px;
    color: #606266;
  }
}
</style>
